<template>
  <v-overlay z-index="201" :value="progress">
    <v-dialog v-model="progress" hide-overlay persistent width="400">
      <v-card style="height: 100px">
        <v-progress-linear
          class="ma-0"
          height="20"
          indeterminate
          color="primary"
        ></v-progress-linear>
        <p class="ma-0" style="font-size: 20px; padding: 15px">
          {{ $t("Пожалуйста, подождите...") }}
        </p>
      </v-card>
    </v-dialog>
  </v-overlay>
</template>
<script lang="ts" >
import baseModule from "@/store/base.module";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "AppProgress",
})
export default class extends Vue {
  get progress() {
    return baseModule.progress;
  }
}
</script>
<style lang="scss" >
</style>